module.exports = __webpack_public_path__ + "img/ueber-mich_3000.c2eabdd6.png";